"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookAuthMethodType = void 0;
exports.WebhookAuthMethodType = {
    Hmac: "hmac",
    Oauth2: "oauth2",
};
